function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Paginator } from '@domain-group/fe-blueprint-ui/pagination';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AllhomesSearchListingCard } from '@domain-group/fe-co-allhomes-listing-card';
import { BtrInfoMessage } from '@domain-group/fe-co-allhomes-shared-components';
import insertFluidAds from '../../utils/insert-fluid-ads';
import AllhomesListingNoSearchResults from '../allhomes-listing-no-search-results';
import * as styles from './allhomes-listing-list-search-results.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ListSearchResults = props => {
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var mobile = props.media.mobile;
  var hasBTR = Boolean(props.searchResults.find(result => {
    var _result$development;
    return (result === null || result === void 0 ? void 0 : (_result$development = result.development) === null || _result$development === void 0 ? void 0 : _result$development.type) === 'RENTAL';
  }));
  var showFluidAds = mobile && !props.inlineAdsDisabled;
  var listingList = props.searchResults.map(result => ___EmotionJSX("div", {
    css: styles.row(),
    key: "listing-".concat(result.listing.id)
  }, ___EmotionJSX(AllhomesSearchListingCard, _extends({
    appearance: mobile ? 'vertical' : 'horizontal',
    css: styles.item,
    onAddToWatchlist: props.onAddToWatchlist
  }, result))));
  return ___EmotionJSX("div", {
    css: styles.searchContent({
      hasNoResult: isEmpty(props.searchResults),
      hasSingleFeaturedProperty: mobile && props.featuredProperties.length === 1
    })
  }, !isEmpty(props.searchResults) && ___EmotionJSX("div", {
    css: styles.items({
      hasSingleFeaturedProperty: mobile && props.featuredProperties.length === 1
    })
  }, hasBTR && ___EmotionJSX("div", {
    css: styles.btrInfo
  }, ___EmotionJSX(BtrInfoMessage, {
    variant: "search-result"
  })), showFluidAds ? insertFluidAds(listingList, {
    adRowStyle: styles.row({
      isAd: true,
      isFluid: true
    })
  }) : listingList), isEmpty(props.searchResults) && ___EmotionJSX(AllhomesListingNoSearchResults, {
    media: props.media,
    isDefaultSearch: props.isDefaultSearch,
    propertiesOfTheWeek: isEmpty(props.featuredProperties) ? props.propertiesOfTheWeek : [],
    onClearFilter: props.onClearFilter,
    onPropertyAlertClick: props.onPropertyAlertClick
  }), props.totalPages > 1 && ___EmotionJSX(Paginator, {
    currentPage: props.currentPage,
    totalPages: props.totalPages,
    urlTemplate: getAbsoluteUrl === null || getAbsoluteUrl === void 0 ? void 0 : getAbsoluteUrl(props.paginatorUrlTemplate),
    onPageChange: props.onPageChange
  }));
};
ListSearchResults.propTypes = {
  media: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  searchResults: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types
  inlineAds: PropTypes.shape({
    urls: PropTypes.arrayOf(PropTypes.string).isRequired,
    numberOfListingsPerAd: PropTypes.number.isRequired
  }),
  inlineAdsDisabled: PropTypes.bool,
  isDefaultSearch: PropTypes.bool.isRequired,
  featuredProperties: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types
  propertiesOfTheWeek: PropTypes.arrayOf(PropTypes.shape({})),
  onAddToWatchlist: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
  onClearBtr: PropTypes.func,
  onPropertyAlertClick: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  paginatorUrlTemplate: PropTypes.string.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onInlineAdClick: PropTypes.func
};
ListSearchResults.defaultProps = {
  searchResults: [],
  inlineAds: {
    urls: [],
    numberOfListingsPerAd: 6
  },
  inlineAdsDisabled: false,
  currentPage: 1,
  totalPages: 1,
  featuredProperties: [],
  propertiesOfTheWeek: [],
  onInlineAdClick: () => {},
  onClearBtr: () => {}
};
export default ListSearchResults;